import { SWEPT_DESTINATIONS } from '../../../shared/playtest';

/** Where command-zone cards go when a reshuffle sweeps them (design O3). The engine owns the list. */
export const [SWEPT_TO_COMMAND, SWEPT_TO_LIBRARY] = SWEPT_DESTINATIONS;
export const SWEPT_TOGGLE_LABEL = 'Shuffles return command-zone cards to the command zone';

export const sweptToCommand = (to) => to === SWEPT_TO_COMMAND;
